/* src/app/admin-dashboard/product/list-product/list-product.component.css */
.productDiv {
  overflow-y: scroll;
  height: calc(100vh - 200px);
}
input[type=file] {
  width: 90px;
  color: transparent;
  background-color: transparent;
}
.example-form {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}
.example-full-width {
  width: 100%;
}
.list {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding: 10px;
  width: 100%;
  height: 50px;
  margin: 5px;
  display: inline-block;
  cursor: pointer;
}
.band {
  width: 90%;
  max-width: 1240px;
  margin: 0 auto;
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-gap: 10px;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding: 70px 100px;
  font-size: 20px;
  width: 100%;
  height: 160px;
  display: inline-block;
  cursor: pointer;
}
::ng-deep app-table-standard-layout .disabled-product-row {
  background-color: #f1d475 !important;
}
/*# sourceMappingURL=list-product.component.css.map */
